<template>
  <AppTooltip>
    <template #activator="{ props }">
      <app-button
        type="icon"
        size="x-small"
        data-locator="attachments-shortcut-button"
        @click="onOpenChecklistPane"
        v-bind="props"
        class="app-button--compact"
      >
        <app-material-icon
          name="attach_file"
        />
        <span class="text-text-tertiary">{{ filesCount }}</span>
      </app-button>
    </template>
    <span>
      {{ hasAccessibleFiles
        ? $t('project.checklist.table.ChecklistTableTaskShortcutDocument.attachedFiles', { count: filesCount })
        : $t('project.checklist.table.ChecklistTableTaskShortcutDocument.noFile')
      }}
    </span>
  </AppTooltip>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'


export default {
  name: 'ChecklistTableTaskShortcutDocument',
  components: {
    AppTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['currentUserRights', 'isCurrentUserPm']),
    filesCount () {
      return this.item?.files ? Object.keys(this.item.files).length : 0
    },
    hasAccessibleFiles () {
      return this.filesCount > 0
    },
    isButtonDisplayed () {
      if (this.isCurrentUserPm || this.currentUserRights.canUpload) {
        return true
      }
      return this.hasAccessibleFiles
    },
  },
  methods: {
    ...mapActions('checklist', [OPEN_CHECKLIST_PANE]),
    onOpenChecklistPane() {
      this.OPEN_CHECKLIST_PANE({
        isOpen: true,
        parent: this.parent,
        tab: 'files',
        tasks: [this.item],
      })
    },
  },
}
</script>

